import { AccessTimeSharp, Close, MoreVert, RemoveRedEye, Search, TrendingUpSharp } from "@mui/icons-material";
import moment from "moment";
import React from "react";
import { Action } from "../../../../components";
import { ThemeContext } from "../../../../context/theme/ThemeContext";
import "./grade.module.scss";

function Grade(props) {
  const { theme, changeTheme } = React.useContext(ThemeContext);
  const { data } = props;
  return (
    <div
      className={
        theme === "light" ? "w-fit l_r_b d_t" : "grade_layout d_r_b l_t"
      }
    >

      <hr />
      <div className="responsive_table w-100">
        {/* {JSON.stringify(data[0].student_quiz?.course_section_item?.title)} */}
        <table className="table">
          <thead>
            <tr>
              <th>Type</th>
              <th>Score</th>
              <th>Status</th>
            </tr>
          </thead>
          <tbody>
            {data?.student_quiz?.map((item, index) => {
              return (
                <tr key={index} >
                  <td>{item?.course_section_item?.title}</td>
                  <td>{item?.score}</td>
                  <td>
                    <span className={item?.is_complete == 1 ? "btn active_course text-white" : "btn btn-warning"}>{item?.is_complete == 1 ? "Marked" : "Pending"}</span>
                  </td>
                  {/* <td>{moment(item?.course_section_item?.student_quiz?.submit_date).format("LL")}</td>
                    <td></td> */}
                </tr>
              )
            })}
            {data?.student_assignment?.map((item, index) => {
              return (
                <tr key={index} >
                  <td>{item?.course_section_item?.title}</td>
                  {item?.is_complete == 1&&<td>{item?.score}</td>}
                  {item?.is_complete != 1&&<td></td>}
                  <td>
                    <span className={item?.is_complete == 1 ? "btn active_course text-white" : "btn btn-warning"}>{item?.is_complete == 1 ? "Marked" : "Pending Score"}</span>
                  </td>
                  {/* <td>{moment(item?.course_section_item?.student_quiz?.submit_date).format("LL")}</td>
                    <td></td> */}
                </tr>
              )
            })}
          </tbody>
        </table>
      </div>
    </div>
  );
}

export default Grade;
